import { render, staticRenderFns } from "./GiftVoucher.vue?vue&type=template&id=1f8bc49d"
import script from "./GiftVoucher.vue?vue&type=script&lang=js"
export * from "./GiftVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ErrorSummary: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/error-summary/ErrorSummary.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,FormVoucher: require('/home/runner/work/platform/platform/packages/client/src/components/forms/voucher/FormVoucher.vue').default,Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default})
